<template>
    <section>
        <div class="detailColumn__card">
            <p>
                Please provide the following information to access this content. Already a member?
                <a :href="loginUrl" class="link -login -underline -dark">Login</a>
            </p>
            <form
                id="pardot-gate-form"
                class="form"
                method="POST"
                enctype="application/x-www-form-urlencoded"
                :action="formAction"
                @submit.prevent="submit"
                data-vv-scope="pardot-form"
            >
                <div class="text">
                    <label for="firstname">First Name <span class="required">*</span></label>
                    <input
                        data-vv-as="First Name"
                        aria-label="First Name"
                        title="First Name"
                        v-validate="rules['firstname']"
                        v-model="firstname"
                        type="text"
                        name="firstname"
                    />
                    <p
                        class="messaging -error -subtle"
                        v-show="errors.has('pardot-form.firstname')"
                        v-text="errors.first('pardot-form.firstname')"
                    ></p>
                </div>
                <div class="text">
                    <label for="lastname">Last Name <span class="required">*</span></label>
                    <input
                        data-vv-as="Last Name"
                        aria-label="Last Name"
                        title="Last Name"
                        v-validate="rules['lastname']"
                        v-model="lastname"
                        type="text"
                        name="lastname"
                    />
                    <p
                        class="messaging -error -subtle"
                        v-show="errors.has('pardot-form.lastname')"
                        v-text="errors.first('pardot-form.lastname')"
                    ></p>
                </div>
                <div class="text">
                    <label for="company">Company/Firm <span class="required">*</span></label>
                    <input
                        data-vv-as="Company/Firm"
                        aria-label="Company/Firm"
                        title="Company/Firm"
                        v-validate="rules['company']"
                        v-model="company"
                        type="text"
                        name="company"
                    />
                    <p
                        class="messaging -error -subtle"
                        v-show="errors.has('pardot-form.company')"
                        v-text="errors.first('pardot-form.company')"
                    ></p>
                </div>
                <div class="text">
                    <label for="title">Job Title <span class="required">*</span></label>
                    <input
                        data-vv-as="Job Title"
                        aria-label="Job Title"
                        title="Job Title"
                        v-validate="rules['title']"
                        v-model="title"
                        type="text"
                        name="title"
                    />
                    <p
                        class="messaging -error -subtle"
                        v-show="errors.has('pardot-form.title')"
                        v-text="errors.first('pardot-form.title')"
                    ></p>
                </div>
                <div class="text">
                    <label for="email">Business Email <span class="required">*</span></label>
                    <input
                        data-vv-as="Business Email"
                        aria-label="Business Email"
                        title="Business Email"
                        v-validate="rules['email']"
                        v-model="email"
                        type="text"
                        name="email"
                    />
                    <p
                        class="messaging -error -subtle"
                        v-show="errors.has('pardot-form.email')"
                        v-text="errors.first('pardot-form.email')"
                    ></p>
                </div>
                <div class="select">
                    <input type="hidden" name="country" v-model="country.label">
                    <label for="country">Country <span class="required">*</span></label>
                    <v-select
                        class="select__options"
                        data-vv-as="Country"
                        v-model="country"
                        name="country_select"
                        title="Country"
                        v-validate:country="rules['country']"
                        :transition="null"
                        :options="countryOptions"
                    ></v-select>
                    <p
                        class="messaging -error -subtle"
                        v-show="errors.has('pardot-form.country')"
                        v-text="errors.first('pardot-form.country')"
                    ></p>
                </div>
                <div class="checkboxes">
                    <div class="checkbox">
                        <input
                            data-vv-as="Consent Provided"
                            title="Consent Provided"
                            data-vv-name="Consent_Provided__c"
                            id="Consent_Provided__c"
                            name="Consent_Provided__c"
                            v-model="Consent_Provided__c"
                            v-validate="rules['Consent_Provided__c']"
                            type="checkbox"
                            value="true"
                            class="checkbox__input"
                        />
                        <label for="Consent_Provided__c" class="checkbox__label">
                            By checking this box, you consent to receive emails from Cutter Associates. You may opt out
                            of these emails at any time. For further information, please consult the
                            <a href="/privacy" target="_blank">Privacy Policy</a> and
                            <a href="/terms-of-use" target="_blank">Terms of Use Policy</a>.
                        </label>
                    </div>
                </div>
                <div>
                    <p
                        class="messaging -error -subtle"
                        v-show="errors.has('pardot-form.Consent_Provided__c')"
                        v-text="errors.first('pardot-form.Consent_Provided__c')"
                    ></p>
                </div>
                <div v-if="errorMessage">
                    <p class="messaging -error -subtle" v-text="errorMessage"></p>
                </div>
                <button type="submit" class="button">Submit</button>
            </form>
        </div>
    </section>
</template>

<script>
    import Vue from 'vue';
    import Select from 'vue-select';
    import VeeValidate from 'vee-validate';
    import locationData from "./location-data.js";

    Vue.component('v-select', Select);

    Vue.use(VeeValidate, {
        events: ''
    });

    export default {
        props: {
            formAction: String,
            loginUrl: String,
        },

        data() {
            return {
                company: null,
                Consent_Provided__c: false,
                country: {
                    value: null,
                    label: null
                },
                email: null,
                firstname: null,
                lastname: null,
                title: null,
            }
        },

        computed: {
            countryOptions() {
                return locationData.countries;
            },

            errorMessage() {
                if (this.error) {
                    return this.error;
                } else if (this.hasErrors) {
                    return "Please correct the invalid fields above.";
                }
            },

            hasErrors() {
                return this.errors.items.length > 0 ? true : false;
            },

            rules() {
                return {
                    country: {
                        required: true,
                    },
                    company: {
                        required: true,
                        containsLetter: true,
                        max: 50,
                    },
                    Consent_Provided__c: {
                        required: true,
                    },
                    email: {
                        required: true,
                        email: true,
                    },
                    firstname: {
                        required: true,
                        containsLetter: true,
                        max: 30,
                    },
                    lastname: {
                        required: true,
                        containsLetter: true,
                        max: 50,
                    },
                    title: {
                        required: true,
                        containsLetter: true,
                        max: 100,
                    }
                }
            }
        },

        mounted() {
            this.$validator.extend("containsLetter", {
                getMessage: (field) => `The ${field} field must have at least 1 letter`,
                validate: (value) => /[a-z]/i.test(value),
            });
        },

        methods: {
            submit() {
                console.log('Submitting.');
                this.$validator.validateAll('pardot-form').then(result => {
                    // Validation failed
                    if (result === false) {
                        return;
                    }

                    const form = document.getElementById('pardot-gate-form');
                    form.submit();
                });
            }
        }
    }
</script>